import {createCachedColumnSelector} from './createCachedColumnSelector';

// Hidden columns are excluded to mirror the rendered pinned partition
// (useOrderedVisibleColumns): sticky offsets and edge-shadow keys derived from
// this selector must only account for columns that actually render — a hidden
// pinned column would otherwise shift every following pinned column's offset
// (T20-138452).
export const usePinnedLeftColumns = createCachedColumnSelector(
  (col) => col.pinned === 'LEFT' && col.hidden !== true
);
